<div class="modal active defaultAltperCal">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 class="title">Default Altitudes - Coverage/Performance Calculation</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngDefaultAltitudesForm" [formGroup]="form" id="defaultAltitudesForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Single Altitude Parameters (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Single Level Altitude</label>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT"
                    (input)='updateSingleLevelAltitudeValue("m",$event.target.value)'
                    formControlName="singleLevelAltitudeFT"
                    type="number"
                    name="singleLevelAltitudeFT"
                    id="singleLevelAltitudeFT"
                    class="defaultAltitudesInput"
                  />
                  <span>[ft]</span>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeM"
                    (input)='updateSingleLevelAltitudeValue("ft", $event.target.value)'
                    formControlName="singleLevelAltitudeM"
                    type="number"
                    name="singleLevelAltitudeM"
                    id="singleLevelAltitudeM"
                    class="defaultAltitudesInput"
                  />
                  <span>[m]</span>
                  <span class="error" *ngIf="form.get('singleLevelAltitudeM').errors">
                    The single level altitude value should be between 100 and 60000 ft or 30.48 and 18288 m.
                   </span>
                </div>
              </div>
            </div>

          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Altitude Range Parameters (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Altitude</label>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT"
                    (input)='updateMaxAltitudeValue("m",$event.target.value)'
                    formControlName="maxAltitudeFT"
                    type="number"
                    name="maxAltitudeFT"
                    id="maxAltitudeFT"
                    class="defaultAltitudesInput"
                  />
                  <span>[ft]</span>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.maxAltitudeM"
                    (input)='updateMaxAltitudeValue("ft", $event.target.value)'
                    formControlName="maxAltitudeM"
                    type="number"
                    name="maxAltitudeM"
                    id="maxAltitudeM"
                    class="defaultAltitudesInput"
                  />
                  <span>[m]</span>
                  <span class="error" *ngIf="form.get('maxAltitudeM').errors">
                    The max Altitude value shouwld be between 0 and 60000 ft or 0 and 18288 m.
                   </span>
                </div>
                <div>
                  <label for="">Altitude Increment</label>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementFT"
                    (input)='updateAltitudeIncrementValue("m",$event.target.value)'
                    formControlName="altitudeIncrementFT"
                    type="number"
                    name="altitudeIncrementFT"
                    id="altitudeIncrementFT"
                    class="defaultAltitudesInput"
                  />
                  <span>[ft]</span>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementM"
                    (input)='updateAltitudeIncrementValue("ft", $event.target.value)'
                    formControlName="altitudeIncrementM"
                    type="number"
                    name="altitudeIncrementM"
                    id="altitudeIncrementM"
                    class="defaultAltitudesInput"
                  />
                  <span>[m]</span>
                  <span class="error" *ngIf="form.get('altitudeIncrementM').errors">
                    The Altitude Increment value shouwld be between 100 and 60000 ft or 30.48 and 18288 m.
                   </span>
                </div>
                <div>
                  <label for="">Min Altitude</label>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.minAltitudeFT"
                    (input)='updateMinAltitudeValue("m",$event.target.value)'
                    formControlName="minAltitudeFT"
                    type="number"
                    name="minAltitudeFT"
                    id="minAltitudeFT"
                    class="defaultAltitudesInput"
                  />
                  <span>[ft]</span>
                  <input
                    maxlength="10"
                    [(ngModel)]="configurationController.currentConfiguration.defaultAltitudes.minAltitudeM"
                    (input)='updateMinAltitudeValue("ft", $event.target.value)'
                    formControlName="minAltitudeM"
                    type="number"
                    name="minAltitudeM"
                    id="minAltitudeM"
                    class="defaultAltitudesInput"
                  />
                  <span>[m]</span>
                  <span class="error" *ngIf="form.get('minAltitudeM').errors">
                    The Min Altitude value shouwld be between 0 and 60000 ft or 30.48 and 18288 m.
                   </span>
                   <span class="error" *ngIf="form.errors">
                    The Min Altitude value should be smaller than Max Altitude value.
                   </span>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
